import getBrowser from '../utils/get-browser';
export default function (app) { // todo ezt a service-t be kell húzni minden app-ba, hogy mindenhol figyelje és küldje a hibákat
	app.factory('$exceptionHandler', ['$log', '$injector', function ($log, $injector) {
		return function myExceptionHandler(exception, cause) {
			let BaseService = $injector.get('BaseService');
			$log.error(exception, cause);

			// Bizonyos JS hibákat nem küldünk a Java-nak, csak böngészőben jelenítünk meg
			if (skipBlacklistedErrors(exception)) {
				return;
			}

			let browser = getBrowser();
			let errorMessage = '';
			let fileName = '';
			let pageURI = window.location ? window.location.href.replace(window.location.origin, '') : '';
			let stack = exception.stack ? exception.stack : '';
			if (stack) fileName = searchStack(stack, '.js');

			errorMessage += cause ? 'Caused by: ' + cause + '\n' : '';
			errorMessage += exception.message ? 'Message: ' + exception.message + '\n' : '';

			let params = {
				body: {
					requestId: '', // TODO get request id
					exception: exception.toString(),
					message: errorMessage,
					browserType: browser.userAgent,
					browserVersion: browser.version,
					pageURI: pageURI,
					fileName: fileName ? fileName : '',
					stack: stack
				}
			};
			BaseService.createPromise('logError', params); // todo ezt a promiset megírni és Java oldalon lekezelni a hibákat
		};

		function searchStack(stack, type) {
			let result = '';
			if (stack && stack.length && stack.indexOf(type) > -1) {
				result = stack.substring(stack.indexOf('http'), stack.indexOf(type) + type.length)
			}
			return result;
		}

		function skipBlacklistedErrors(exception) {
			let error;
			if (exception) {
				error = exception.toString();

				if (error.includes('$rootScope:inprog') || error.includes('$rootScope:infdig') || error.includes('ng:cpws')) {
					return true;
				}
			}

			return false;
		}
	}]);
};
